import { Box, Typography } from '@material-ui/core';
import type { IAsyncApiSpecification } from '@internal/schemas-common';
import { AsyncApiViewer } from '@internal/ui-common';
import { InfoCard } from '@backstage/core-components';

interface SchemaSectionProps {
  titleOfComponent: string;
  specification: IAsyncApiSpecification['specification'] | null;
}

function SchemaSection({ titleOfComponent, specification }: SchemaSectionProps) {
  return (
    <InfoCard title={titleOfComponent}>
      <Box
        maxHeight="22rem"
        overflow="auto"
        display="flex"
        justifyContent={specification ? 'flex-start' : 'center'}
        alignItems={specification ? 'flex-start' : 'center'}
      >
        {specification ? (
          <AsyncApiViewer schema={specification} />
        ) : (
          <Typography>{`No ${titleOfComponent.toLowerCase()} schema available`}</Typography>
        )}
      </Box>
    </InfoCard>
  );
}

export { SchemaSection };
